(function () {
  function inIFrame() {
    try { return window.self !== window.top; }
    catch { return true; } // cross-origin iframe throws => treat as iframe
  }

  function apply() {
    const b = document.body;
    if (!b) return;
    if (inIFrame()) {
      b.classList.add("preview");
    }
  }

  document.addEventListener("DOMContentLoaded", apply);
  document.addEventListener("turbo:load", apply);

  new MutationObserver(apply).observe(document.documentElement, { childList: true });
})();
